<template>
  <v-data-table :headers="headers" :items="assets">
    <template v-slot:item.access_level="{ item }">
      <v-chip color="#7986cb" dark>
        {{ item.access_level }}
      </v-chip>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    assets: Array,
  },
  data: function () {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "measurement_units.description" },
        { text: "Created", value: "created_at" },
        { text: "File type", value: "file_type" },
        { text: "Access level", value: "access_level" },
      ],
    };
  },
};
</script>
